import { useNavigate } from "react-router-dom";
import { Card } from "../../../components/cards";
import { useMe } from "../../users/hooks/useMe";
import { Activity, Building2, Megaphone, FileText, Newspaper } from "lucide-react";
import { UsersInfos } from "../../users/components";
import { useCustomers } from "../../customers/hooks";
import { RecentCustomersWidget } from "../components";
import { MyTasksWidget } from "../../customer-tasks/components";

export const Admin = () => {
  const navigate = useNavigate();
  const { data } = useMe();
  const { data: customersData } = useCustomers({ where: {} });

  return (
    <div className="space-y-4 p-2">
      {/* Welcome Banner */}
      <Card
        padding="md"
        className="bg-gradient-to-r from-primary-600 to-primary-700 border-0 text-white"
      >
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center backdrop-blur-sm">
            <Activity className="w-6 h-6 text-white" />
          </div>
          <div>
            <h2 className="text-lg font-bold mb-1">
              Bienvenue, {data?.me?.firstname || "Admin"}
            </h2>
            <p className="text-sm text-white/90">
              Vue d'ensemble de votre activité de prospection
            </p>
          </div>
        </div>
      </Card>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div onClick={() => navigate("/customers")} className="cursor-pointer">
          <Card hover padding="sm" className="shadow-sm border border-gray-200">
            <div className="flex items-center justify-between gap-2">
              <div className="flex-1 min-w-0">
                <p className="text-[10px] sm:text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">
                  Clients
                </p>
                <p className="text-sm sm:text-lg font-bold text-gray-900 truncate">
                  {customersData?.customers?.total ?? 0}
                </p>
                <p className="text-[10px] sm:text-xs text-gray-500 mt-0.5 hidden sm:block">
                  Clients enregistrés
                </p>
              </div>
              <div className="bg-blue-50 p-2 sm:p-3 rounded-lg flex-shrink-0">
                <Building2 className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600" />
              </div>
            </div>
          </Card>
        </div>

        <div onClick={() => navigate("/prospections")} className="cursor-pointer">
          <Card hover padding="sm" className="shadow-sm border border-gray-200">
            <div className="flex items-center justify-between gap-2">
              <div className="flex-1 min-w-0">
                <p className="text-[10px] sm:text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">
                  Prospections
                </p>
                <p className="text-[10px] sm:text-xs text-gray-500 mt-0.5 hidden sm:block">
                  Suivi du démarchage
                </p>
              </div>
              <div className="bg-purple-50 p-2 sm:p-3 rounded-lg flex-shrink-0">
                <Megaphone className="w-5 h-5 sm:w-6 sm:h-6 text-purple-600" />
              </div>
            </div>
          </Card>
        </div>

        <div onClick={() => navigate("/reports")} className="cursor-pointer">
          <Card hover padding="sm" className="shadow-sm border border-gray-200">
            <div className="flex items-center justify-between gap-2">
              <div className="flex-1 min-w-0">
                <p className="text-[10px] sm:text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">
                  Rapports SEO
                </p>
                <p className="text-[10px] sm:text-xs text-gray-500 mt-0.5 hidden sm:block">
                  Suivi hebdomadaire
                </p>
              </div>
              <div className="bg-orange-50 p-2 sm:p-3 rounded-lg flex-shrink-0">
                <FileText className="w-5 h-5 sm:w-6 sm:h-6 text-orange-600" />
              </div>
            </div>
          </Card>
        </div>

        <div onClick={() => navigate("/users")} className="cursor-pointer">
          <UsersInfos />
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <RecentCustomersWidget />
        <MyTasksWidget />
      </div>

      <div onClick={() => navigate("/articles")} className="cursor-pointer">
        <Card hover padding="md">
          <div className="flex items-center gap-3">
            <div className="bg-indigo-50 text-indigo-600 p-2.5 rounded-lg flex-shrink-0">
              <Newspaper className="w-5 h-5" />
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-900">Articles</p>
              <p className="text-xs text-gray-500">Voir les articles rédigés pour les clients</p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};
